import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RequestState } from '../../../shared/definitions/request-state.enum';
import { SimXTaxonomyTerm } from '../../../shared/models/entities/simx-taxonomy-term.model';
import { State } from './taxonomy-store.state';

const getTaxonomyTermsRequestState = (state: State): RequestState =>
  state.taxonomyTermsRequestState;
const getTaxonomyTerms = (state: State): Array<SimXTaxonomyTerm> =>
  state.taxonomyTerms;

export const selectTaxonomyState = createFeatureSelector<State>('taxonomy');

export const selectTaxonomyTermsRequestState = createSelector(
  selectTaxonomyState,
  getTaxonomyTermsRequestState,
);
export const selectTaxonomyTerms = createSelector(
  selectTaxonomyState,
  getTaxonomyTerms,
);
